import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, LayoutList, Settings } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const items = [
  { key: "home", labelKey: "nav.home", path: "/", match: ["/", "/app"], icon: Home },
  { key: "decisions", labelKey: "nav.decisions", path: "/decisions", match: ["/decisions"], icon: LayoutList },
  { key: "settings", labelKey: "nav.settings", path: "/settings", match: ["/settings"], icon: Settings },
];

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLang();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 inset-x-0 z-40 h-[68px] backdrop-blur-xl bg-decide-canvas/90 border-t border-decide-line"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="decide-shell h-full flex items-center justify-around">
        {items.map((it) => {
          const active = it.match.includes(location.pathname);
          const Icon = it.icon;
          const label = t(it.labelKey);
          return (
            <button
              key={it.key}
              data-testid={`nav-${it.key}`}
              onClick={() => navigate(it.path)}
              className="flex flex-col items-center gap-1 px-4 py-1.5 transition-colors"
              aria-label={label}
            >
              <Icon size={22} strokeWidth={active ? 2.1 : 1.6} className={active ? "text-decide-forest" : "text-decide-mute"} />
              <span className={`text-[11px] font-medium ${active ? "text-decide-forest" : "text-decide-mute"}`}>{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
